import request from '@/utils/request'

export function login(username, password, captchaToken) {
  return request({
    url: '/services/loginUser',
    method: 'post',
    data: {
      identifier: username,
      password: password,
      captchaToken: captchaToken
    }
  })
}

export function loginIC(username, password, captchaToken) {
  return request({
    url: '/mypetrol/loginIC',
    method: 'post',
    data: {
      identifier: username,
      password: password,
      captchaToken: captchaToken
    }
  })
}

export function getInfo() {
  return request({
    url: '/users/me',
    method: 'get'
  })
}

export function getService() {
  return request({
    url: '/services/personal/' + process.env.SERVICE_NAME,
    method: 'get'
  })
}

export function joinService(data) {
  return request({
    url: '/services/join/' + process.env.SERVICE_NAME,
    method: 'post',
    data
  })
}

export function uploadPfp(data) {
  return request({
    url: '/services/uploadPfp/' + process.env.SERVICE_NAME,
    method: 'post',
    headers: { 'content-type': 'multipart/form-data' },
    data
  })
}

export function changeUserData(data) {
  return request({
    url: '/services/modify/' + process.env.SERVICE_NAME,
    method: 'post',
    data
  })
}

export function forgotPassword(data) {
  return request({
    url: '/auth/forgot-password',
    method: 'post',
    data
  })
}

export function resetPassword(data) {
  return request({
    url: '/auth/reset-password',
    method: 'post',
    data
  })
}

export function changePassword(id, data) {
  return request({
    url: `/users/${id}/change_password`,
    method: 'put',
    data
  })
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'get'
  })
}

export function moduleApply(incomingModule) {
  return request({
    url: '/services/subsidy/moduleApply',
    method: 'post',
    data: {
      module: incomingModule
    }
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js